import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['sidebar', 'overlay'];

  toggle() {
    if (this.sidebarTarget.classList.contains('tw-translate-x-full')) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.sidebarTarget.classList.remove('tw-translate-x-full');
    this.overlayTarget.classList.remove('tw-hidden');
  }

  close() {
    this.sidebarTarget.classList.add('tw-translate-x-full');
    this.overlayTarget.classList.add('tw-hidden');
  }
}
